import { get, post, put, remove } from "../../api_helper";
import * as url from "../../url_helper";

const baseURL = process.env.REACT_APP_API_DOTNET_URL;

export const createTDPEmployeeMasterListLog = (payload) => post(baseURL + url.TDP_EMPLOYEE_MASTER_LIST_LOG, payload);
export const getTDPEmployeeMasterListLogDetails = (id) => get(`${baseURL + url.TDP_EMPLOYEE_MASTER_LIST_LOG}/${id}`);
export const updateTDPEmployeeMasterListLog = (id, payload) => put(`${baseURL + url.TDP_EMPLOYEE_MASTER_LIST_LOG}/${id}`, payload);
export const deleteTDPEmployeeMasterListLog = (id) => remove(`${baseURL + url.TDP_EMPLOYEE_MASTER_LIST_LOG}/${id}`);